<template>
  <a-form
    ref="advertisementForm"
    :model="form"
    layout="vertical"
    class="ml-10 my-10 mr-0"
  >
    <a-row :gutter="24">
      <a-col :span="6">
        <a-form-item label="Name">
          <a-input v-model:value="form.name" placeholder="Name" />
        </a-form-item>
      </a-col>
      <a-col :span="6">
        <a-form-item label="Email">
          <a-input v-model:value="form.email" placeholder="Email" />
        </a-form-item>
      </a-col>
      <a-col :span="6">
        <a-form-item label="Age">
          <a-input v-model:value="form.age" placeholder="Age" />
        </a-form-item>
      </a-col>

      <a-col :span="6">
        <Select
          class="mt-2"
          v-model="form.gender"
          placeholder="Gender"
          :options="genders"
        />
      </a-col>
    </a-row>
    <a-row :gutter="20">
      <a-col :span="6">
        <a-form-item label="Niche">
          <a-input v-model:value="form.niche" placeholder="Niche" />
        </a-form-item>
      </a-col>
      <a-col :span="6">
        <a-form-item label="City">
          <a-input v-model:value="form.city" placeholder="City" />
        </a-form-item>
      </a-col>
      <a-col :span="6">
        <Select
          class="mt-2"
          v-model="form.country"
          placeholder="Country"
          :options="ugc_countries"
        />
      </a-col>
      <a-col :span="6">
        <Select
          class="mt-2"
          v-model="form.industry"
          placeholder="Industry"
          :options="industries"
        />
      </a-col>
    </a-row>
    <a-row :gutter="20">
      <a-col :span="12">
        <a-form-item label="Minimum Project">
          <a-input
            v-model:value="form.minimum_project"
            placeholder="Minimum Project"
          />
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <a-form-item label="Minimum Price">
          <a-input
            v-model:value="form.minimum_price"
            placeholder="Minimum Price"
          />
        </a-form-item>
      </a-col>
    </a-row>
    <a-row :gutter="20">
      <a-col :span="12">
        <a-form-item label="Link from Creator">
          <a-input
            v-model:value="form.link_from_creator"
            placeholder="Link from Creator"
          />
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <a-form-item label="Website">
          <a-input v-model:value="form.website" placeholder="Website" />
        </a-form-item>
      </a-col>
    </a-row>
    <a-row :gutter="20">
      <a-col :span="12">
        <a-form-item label="Instagram Link">
          <a-input
            v-model:value="form.instagram_link"
            placeholder="Link from Creator"
          />
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <a-form-item label="Tiktok Link">
          <a-input v-model:value="form.tiktok_link" placeholder="Tiktok Link" />
        </a-form-item>
      </a-col>
    </a-row>
    <a-row :gutter="20">
      <a-col :span="12">
        <a-form-item label="Twitter Link">
          <a-input
            v-model:value="form.twitter_link"
            placeholder="Twitter Link"
          />
        </a-form-item>
      </a-col>
    </a-row>
    <a-row :gutter="24" class="mt-8">
      <a-col :span="12" class="mt-4">
        <a-form-item label="Profile Picture">
          <input type="file" @change="onProfileChanged" />
          <a-input
            class="mt-1"
            v-model:value="form.profile_picture"
            placeholder="Profile Picture"
          />
        </a-form-item>
      </a-col>
      <a-col :span="12" v-if="form.profile_picture" class="mt-4">
        <div class="shadow-sm rounded-xl border">
          <a-row type="flex" justify="space-between" align="center">
            <img
              :src="form.profile_picture"
              alt=""
              class="w-11 h-11 rounded-full mr-2"
            />
          </a-row>
        </div>
      </a-col>
    </a-row>
    <div class="my-3"></div>
    <a-row :gutter="24" class="mt-8">
      <a-col :span="12" class="mt-4">
        <a-form-item label="UGC Creator Video 1">
          <input type="file" @change="onFileChanged1" />

          <a-input
            class="mt-1"
            v-model:value="form.videos[0]"
            placeholder="UGC Creator Video 1"
          />
        </a-form-item>
      </a-col>
      <a-col :span="12" class="mt-4">
        <a-form-item label="UGC Creator Video 2">
          <input type="file" @change="onFileChanged2" />
          <a-input
            class="mt-1"
            v-model:value="form.videos[1]"
            placeholder="UGC Creator Video 2"
          />
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <div
          class="shadow-sm rounded-xl border"
          v-if="typeof form.videos[0] == 'string'"
        >
          <div class="square">
            <video
              class="w-full"
              controls
              v-if="form.videos[0].includes('.mp4')"
            >
              <source :src="form.videos[0]" type="video/mp4" />
            </video>
          </div></div
      ></a-col>
      <a-col :span="12">
        <div
          class="shadow-sm rounded-xl border"
          v-if="typeof form.videos[1] == 'string'"
        >
          <div class="square">
            <video
              class="w-full"
              controls
              v-if="form.videos[1].includes('.mp4')"
            >
              <source :src="form.videos[1]" type="video/mp4" />
            </video>
          </div></div
      ></a-col>
    </a-row>
    <div class="my-3"></div>

    <a-row :gutter="24" class="mt-8">
      <a-col :span="12" class="mt-4">
        <a-form-item label="UGC Creator Video 3">
          <input type="file" @change="onFileChanged3" />
          <a-input
            class="mt-1"
            v-model:value="form.videos[2]"
            placeholder="UGC Creator Video 3"
          />
        </a-form-item>
      </a-col>
      <a-col :span="12" class="mt-4">
        <a-form-item label="UGC Creator Video 4">
          <input type="file" @change="onFileChanged4" />
          <a-input
            class="mt-1"
            v-model:value="form.videos[3]"
            placeholder="UGC Creator Video 4"
          />
        </a-form-item>
      </a-col>
      <a-col :span="12" class="mt-4">
        <div
          class="shadow-sm rounded-xl border"
          v-if="typeof form.videos[2] == 'string'"
        >
          <div class="square">
            <video
              class="w-full"
              controls
              v-if="form.videos[2].includes('.mp4')"
            >
              <source :src="form.videos[2]" type="video/mp4" />
            </video>
          </div></div
      ></a-col>
      <a-col :span="12" class="mt-4">
        <div
          class="shadow-sm rounded-xl border"
          v-if="typeof form.videos[3] == 'string'"
        >
          <div class="square">
            <video
              class="w-full"
              controls
              v-if="form.videos[3].includes('.mp4')"
            >
              <source :src="form.videos[3]" type="video/mp4" />
            </video>
          </div></div
      ></a-col>
    </a-row>
    <div class="my-3"></div>

    <a-row :gutter="24" class="mt-8">
      <a-col :span="12" class="mt-4">
        <a-form-item label="UGC Creator Video 5">
          <input type="file" @change="onFileChanged5" />
          <a-input
            class="mt-1"
            v-model:value="form.videos[4]"
            placeholder="UGC Creator Video 5"
          />
        </a-form-item>
      </a-col>
      <a-col :span="12" class="mt-4">
        <a-form-item label="UGC Creator Video 6">
          <input type="file" @change="onFileChanged6" />
          <a-input
            class="mt-1"
            v-model:value="form.videos[5]"
            placeholder="UGC Creator Video 6"
          />
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <div
          class="shadow-sm rounded-xl border"
          v-if="typeof form.videos[4] == 'string'"
        >
          <div class="square">
            <video
              class="w-full"
              controls
              v-if="form.videos[4].includes('.mp4')"
            >
              <source :src="form.videos[4]" type="video/mp4" />
            </video>
          </div></div
      ></a-col>
      <a-col :span="12">
        <div
          class="shadow-sm rounded-xl border"
          v-if="typeof form.videos[5] == 'string'"
        >
          <div class="square">
            <video
              class="w-full"
              controls
              v-if="form.videos[5].includes('.mp4')"
            >
              <source :src="form.videos[5]" type="video/mp4" />
            </video>
          </div></div
      ></a-col>
    </a-row>
  </a-form>
</template>

<script>
import Select from "@/components/UI/Select/index";
export default {
  components: { Select },
  props: {
    modelValue: Object,
    mediaType: String,
  },

  data() {
    return {
      isLoading: false,
      subindustries: null,
      labelCol: { span: 5 },
      wrapperCol: { span: 16 },
    };
  },
  computed: {
    media_type: {
      get() {
        return this.mediaType;
      },
      set(newValue) {
        this.$emit("update:mediaType", newValue);
      },
    },
    form: {
      get() {
        return this.modelValue;
      },
      set(newValue) {
        this.$emit("update:modelValue", newValue);
      },
    },

    industries() {
      return this.$store.state.industries;
    },
    genders() {
      return this.$store.state.genders;
    },
    ugc_countries() {
      return this.$store.state.ugc_countries;
    },
  },
  methods: {
    handleMediaType(value) {
      this.media_type = value.target.value;
    },
    onProfileChanged(event) {
      this.form.profile_picture = event.target.files[0];
    },
    onFileChanged1(event) {
      this.form.videos[0] = event.target.files[0];
    },
    onFileChanged2(event) {
      this.form.videos[1] = event.target.files[0];
    },
    onFileChanged3(event) {
      this.form.videos[2] = event.target.files[0];
    },
    onFileChanged4(event) {
      this.form.videos[3] = event.target.files[0];
    },
    onFileChanged5(event) {
      this.form.videos[4] = event.target.files[0];
    },
    onFileChanged6(event) {
      this.form.videos[5] = event.target.files[0];
    },
  },
};
</script>

<style></style>
